// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import interpellationEntity from './entities/interpellation.json';
import interpellationMenu from '../pages/interpellation/menu.json';
import interpellationFullForm from '../pages/interpellation/forms/full.json';
import interpellationContextForm from '../pages/interpellation/forms/context.json';
import interpellationMiniForm from '../pages/interpellation/forms/mini.json';
import interpellationLookupForm from '../pages/interpellation/forms/lookup.json';
import interpellationTableView from '../pages/interpellation/views/table.json';
import interpellationStagesView from '../pages/interpellation/views/stages.json';
import interpellationCardsView from '../pages/interpellation/views/cards.json';
import interpellationInlineView from '../pages/interpellation/views/inline.json';
import interpellationBacklogView from '../pages/interpellation/views/backlog.json';
import interpellationSplitView from '../pages/interpellation/views/split.json';
import interpellationCalendarView from '../pages/interpellation/views/calendar.json';
import interpellationDashboardView from '../pages/interpellation/views/dashboard.json';

/** Тип запису «Інтерпеляція» зі сторінками пакета: меню, форми та подання з pages/interpellation/. */
export const interpellationDefinition: IRecordTypeDefinition = {
  ...interpellationEntity,
  views: assembleViewSet({
      table: interpellationTableView,
      stages: interpellationStagesView,
      cards: interpellationCardsView,
      inline: interpellationInlineView,
      backlog: interpellationBacklogView,
      split: interpellationSplitView,
      calendar: interpellationCalendarView,
      dashboard: interpellationDashboardView,
  }),
  form: interpellationFullForm,
  forms: { full: interpellationFullForm, context: interpellationContextForm, mini: interpellationMiniForm, lookup: interpellationLookupForm },
  menu: interpellationMenu,
} as IRecordTypeDefinition;
